requirejs.config({
  "baseUrl": "/Scripts",
  "paths": {
    "app": "app"
  },
  waitSeconds: 20
});

var celuce = null;
require([], function () {
  celuce = bundle.default;
  // now kick off all the delayed jquery onload
  $(function () {
    $.each(_$calls, function (i, f) { f(); });
  });
  celuce.productImages.watchProductThumbs();
  var fb = bundle.default.facebook;
  var track = bundle.default.track;

  $(function () {
    fb.initLogin('210177829395808');
    $('.cloud-zoom, .cloud-zoom-gallery:not(.asset)').CloudZoom();
    $("a[data-gallery^='lightbox']").slimbox({ loop: true, nextKeys: [39, 78, 32] }, null,
      function (el) {
        var def = $(this);
        var thumb = $(el);

        var thumbEnabled = !thumb.attr('id') || thumb.attr('enabled') == 'true';
        var galleryName = def.attr('data-gallery');
        var thumbGallery = thumb.attr('data-gallery');

        var result = thumbEnabled && galleryName && galleryName === thumbGallery;
        if (result) {
          var box = thumb.closest('.product-thumbs');
          if (!box.length) {
            box = thumb.closest('#desktopPreview:visible');
          }
          result = box.length > 0;
        }
        return result;
      });
    // load css
    var $body = $('body');
    $('csslink').each(function (i, link) {
      $body.append($("<link rel='stylesheet' type='text/css' href='" + $(link).attr('href') + "'/>"));
    })
    window.onerror = function (msg, url, line, col, error) {
      track('exception', url, msg + line, 0, true);
    };
    $('*[data-track-as]').click(bundle.default.trackers.trackClick);
  });
});
